import { compareVersions } from 'compare-versions'
import { ref } from 'vue'

const updateAvailable = ref(false)
const clientVersion = import.meta.env.VITE_APP_VERSION

function notifyUpdateAvailable() {
  if (updateAvailable.value) return
  updateAvailable.value = true
}

// Returns true only if serverVersion is strictly newer than the running client build.
// Prevents false positives when the backend cache is stale and returns an older version.
function isNewerVersion(serverVersion) {
  if (!clientVersion || !serverVersion) return false
  try {
    return compareVersions(serverVersion, clientVersion) > 0
  } catch {
    return false
  }
}

// Registered once at module load — no polling, fires only when user returns to tab
document.addEventListener('visibilitychange', async () => {
  if (document.visibilityState !== 'visible') return
  if (updateAvailable.value) return

  try {
    const res = await fetch(`/version.txt?t=${Date.now()}`)
    const version = (await res.text()).trim()
    if (isNewerVersion(version)) {
      notifyUpdateAvailable()
    }
  } catch {
    // ignore — version.txt does not exist in local dev
  }
})

export { notifyUpdateAvailable, isNewerVersion }

export function useVersionCheck() {
  return { updateAvailable }
}
